export enum ManagerPosition {
    Manager,
    RegionalRepresentative
}